import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-redbean-cream flex flex-col items-center justify-center px-4 pt-20 pb-16">
      <div className="text-center max-w-lg">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-redbean-lightcream">
          <span className="w-10 h-10 flex items-center justify-center text-redbean-primary">
            <i className="ri-error-warning-line text-2xl" />
          </span>
        </div>
        <h1
          className="font-heading font-bold text-redbean-coffee mb-3"
          style={{ fontSize: "2.125rem", lineHeight: 1.4 }}
        >
          找不到這個頁面
        </h1>
        <p className="text-redbean-coffee/60 text-[1.1875rem] leading-relaxed mb-8">
          你尋找的頁面可能已被移除或網址有誤。
          <br />
          歡迎回到首頁，繼續探索來加綉綉的紅豆餅與品牌故事。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-8 py-3 bg-redbean-primary text-redbean-cream text-[1.0625rem] font-semibold rounded-full hover:bg-redbean-coffee transition-colors whitespace-nowrap"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-left-line" />
          </span>
          返回首頁
        </Link>
      </div>
    </div>
  );
}